import ResumeViewer from "../components/ResumeViewer";

const Experience = () => {
  return (
    <div
      className="experience pt-4 absolute top-0 left-0 
                    h-screen w-screen"
    >
      <ResumeViewer />
    </div>
  );
};

export default Experience;
